// extracted by mini-css-extract-plugin
var _1 = "InstallModal-module__container___nsTYX";
var _2 = "InstallModal-module__laurels___wontB";
var _3 = "InstallModal-module__salesPitch___tMGYs";
export { _1 as "container", _2 as "laurels", _3 as "salesPitch" }
